<template>
	<div>
		<!-- 单选题, 判断题 -->
		<template  v-if="['1', '4'].includes(itemData.questionType)">
			<el-form-item :prop="itemData.questionCode" :rules="[
				{required: itemData.isRequired == '1', trigger: 'blur', message: '请选择一个选项'}
			]">
				<div class="title" :class="{disabled: disabled}" :data-required="itemData.isRequired == '1' ? '*' : ''">{{serial ? `${serial}. ` : ''}}{{questionName}}（{{question_type_obj[itemData.questionType]}}）</div>
				<div class="tips" :class="{disabled: disabled}" v-show="itemData.tipsText" v-html="tipsText"></div>
				<div class="option">
					<el-radio-group v-model="qForm[itemData.questionCode]" :disabled="disabled">
						<div class="radio-item" v-for="item in itemData.itemList" :key="item.itemCode">
							<el-radio :label="item.itemCode">{{item.itemName}}</el-radio>
							<el-input v-model="item.defaultValue" :disabled="disabled" v-if="item.showType == 2" size="mini" style="width: 180px;" placeholder="请输入" prefix-icon="el-icon-edit" clearable></el-input>
							<el-date-picker v-model="item.defaultValue" :disabled="disabled" v-if="item.showType == 3" value-format="yyyy-MM-dd" type="date" placeholder="请选择" size="mini" style="width: 180px"></el-date-picker>
							<el-date-picker v-model="item.defaultValue" :disabled="disabled" v-if="item.showType == 4" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择" size="mini" style="width: 180px"></el-date-picker>
						</div>
					</el-radio-group>
				</div>
			</el-form-item>
		</template>

		<!-- 多选题 -->
		<template  v-if="itemData.questionType == '2'">
			<el-form-item :prop="itemData.questionCode" :rules="[
				{required: itemData.isRequired == '1', trigger: 'blur', message: '请选择一个选项'}
			]">
				<div class="title"  :class="{disabled: disabled}" :data-required="itemData.isRequired == '1' ? '*' : ''">{{serial ? `${serial}. ` : ''}}{{questionName}}（{{question_type_obj[itemData.questionType]}}）</div>
				<div class="tips" :class="{disabled: disabled}" v-show="itemData.tipsText" v-html="tipsText"></div>
				<div class="option">
					<el-checkbox-group v-model="qForm[itemData.questionCode]" :disabled="disabled">
						<div class="radio-item" v-for="item in itemData.itemList" :key="item.itemCode">
							<el-checkbox :label="item.itemCode">{{item.itemName}}</el-checkbox>
							<el-input v-model="item.defaultValue" :disabled="disabled" v-if="item.showType == 2" size="mini" style="width: 180px;" placeholder="请输入" prefix-icon="el-icon-edit" clearable></el-input>
							<el-date-picker v-model="item.defaultValue" :disabled="disabled" v-if="item.showType == 3" value-format="yyyy-MM-dd" type="date" placeholder="请选择" size="mini" style="width: 180px"></el-date-picker>
							<el-date-picker v-model="item.defaultValue" :disabled="disabled" v-if="item.showType == 4" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择" size="mini" style="width: 180px"></el-date-picker>
						</div>
					</el-checkbox-group>
				</div>
			</el-form-item>
		</template>

		<!-- 下拉题 -->
		<template  v-if="itemData.questionType == '6'">
			<el-form-item :prop="itemData.questionCode" :rules="[
				{required: itemData.isRequired == '1', trigger: 'blur', message: '请选择一个选项'}
			]">
				<div class="title" :class="{disabled: disabled}" :data-required="itemData.isRequired == '1' ? '*' : ''">{{serial ? `${serial}. ` : ''}}{{questionName}}（{{question_type_obj[itemData.questionType]}}）</div>
				<div class="tips" :class="{disabled: disabled}" v-show="itemData.tipsText" v-html="tipsText"></div>
				<div class="option">
					<el-select v-model="qForm[itemData.questionCode]" :disabled="disabled" placeholder="请选择" size="small" style="width: 100%;">
						<el-option v-for="item in itemData.itemList" :key="item.itemCode" :label="item.itemName" :value="item.itemCode"></el-option>
					</el-select>
				</div>
			</el-form-item>
		</template>

		<!-- 简答题 -->
		<template  v-if="itemData.questionType == '3'">
			<el-form-item :prop="itemData.questionCode" :rules="[
				{required: itemData.isRequired == '1', trigger: 'blur', message: '请选择一个选项'}
			]">
				<div class="title" :class="{disabled: disabled}" :data-required="itemData.isRequired == '1' ? '*' : ''">{{serial ? `${serial}. ` : ''}}{{questionName}}（{{question_type_obj[itemData.questionType]}}）</div>
				<div class="tips" :class="{disabled: disabled}" v-show="itemData.tipsText" v-html="tipsText"></div>
				<div class="option">
					<el-input
						type="textarea"
						:disabled="disabled"
						:rows="3"
						v-model="qForm[itemData.questionCode]"
						style="width: 100%;"
						clearable>
					</el-input>
				</div>
			</el-form-item>
		</template>
	</div>
</template>

<script>
export default {
	name: "qFormLibrary",
	props: ['serial', 'itemData', 'qForm', 'sourceType', 'disabled'],
	computed: {
		questionName() {
			return this.itemData.questionName.replace(/[\n]/g, '');
		},
		tipsText() {
			return this.itemData.tipsText.replace(/[\n]/g, '<br />');
		},
	},
	data() {
		return {
			question_type_obj: {
				1: '单选',
				2: '多选',
				3: '简答',
				4: '判断',
				6: '下拉'
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.title {
	width: 100%;
	// height: 30px;
	font-size: 16px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #333;
	line-height: 22px;
	position: relative;

	&.disabled {
		color: #C3C9D0;
	}

	&::before {
		content: attr(data-required);
		color: #F56C6C;
		position: absolute;
		top: 0;
		left: -10px;
	}
}

.tips {
	width: 100%;
	// height: 30px;
	line-height: 30px;
	font-size: 12px;
	color: #666;
	line-height: 1.5;
	padding-left: 14px;

	&.disabled {
		color: #C3C9D0;
	}
}

.option {
	padding: 0 5px;
	width: 100%;

	.radio-item {
		width: 100%;
		display: block;
	}

	& .el-radio {
		margin: 10px;
	}

	& .el-checkbox {
		margin-right: 10px;
	}

	& > .el-input {
	}
}
.el-form-item {
	margin: 0;
	width: 100%;
}
</style>